import CryptoJS from 'crypto-js';

import getKey from './keys';
import { Source } from './interfraces';

export default function (encrypted: string, source?: Source): string {
    return CryptoJS.AES.decrypt(encrypted, getKey(source)).toString(CryptoJS.enc.Utf8);
}
